import { useMutation } from "@apollo/client";
import { AES } from "crypto-js";
import { useSelector } from "react-redux";
import { CBST } from "../../Routes/query";

export const useCbst = (feedback: any) => {
  const { ApiFailureName, requestId, error, cbstAction, storeRequestID, requestIdForGetUrl } =
    useSelector((state: any) => state.paymentDetails);

  const { accountNumber, emailContact } = useSelector((state: any) => state.customerInfoDetails);
  const { cbstKey } = useSelector((state: any) => state.userInfo);

  const encrypt = (content: any, password: any) =>
    AES.encrypt(JSON.stringify({ content }), password).toString();
  const [sendCbstMutation, { loading: cbstLoading }] = useMutation(CBST, {
    fetchPolicy: "network-only",
    onError: (error) => {
      console.log(error);
    },
  });
  const getRequestID = () => {
    switch (ApiFailureName) {
      case "getPaymentMethodURL":
        return requestIdForGetUrl;
      case "getPaymentMethodsForManagePayments":
        return storeRequestID;
      default:
        return requestId;
    }
  };

  const handleSendReport = async () => {
    if (!cbstKey) {
      return;
    }
    try {
      const CbstContent = {
        email: emailContact?.emailAddress,
        accountNumber: accountNumber,
        APIName: ApiFailureName,
        error: error,
        requestId: getRequestID(),
        claritySessionId: sessionStorage?.sessionID,
        customerDescription: feedback,
        action: cbstAction,
      };
      const encryptedData = encrypt(CbstContent, cbstKey);
      await sendCbstMutation({
        variables: {
          payload: encryptedData,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  return {
    cbstLoading,
    sendCbst: handleSendReport,
  };
};
